// import PropTypes from 'prop-types';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

// const EnrollmentInfoForm = ({ form, handleChange, formErrors, isSaving }) => (
//   <Card className="p-4 max-w-2xl mx-auto">
//     <CardHeader>
//       <CardTitle>Enrollment Info</CardTitle>
//     </CardHeader>
//     <CardContent>
//       <form className="space-y-4">
//         {/* Service */}
//         <div>
//           <Label htmlFor="service">Service*</Label>
//           <select
//             id="service"
//             name="service"
//             value={form.service || ''}
//             onChange={handleChange}
//             disabled={isSaving}
//             required
//             className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//           >
//             <option value="">Select Service</option>
//             <option value="studyAbroad">Study Abroad</option>
//             <option value="workpermit">Work Permit</option>
//             <option value="touristVisa">Tourist Visa</option>
//             <option value="examBooking">Exam Booking</option>
//             <option value="training">Training</option>
//           </select>
//           {formErrors.service && <p className="text-red-500 text-sm mt-2">{formErrors.service}</p>}
//         </div>

//         {/* Conditional Fields for studyAbroad, workpermit, touristVisa */}
//         {['studyAbroad', 'workpermit', 'touristVisa'].includes(form.service) && (
//           <div>
//             <div>
//               <Label htmlFor="country">Country*</Label>
//               <select
//                 id="country"
//                 name="country"
//                 value={form.country || ''}
//                 onChange={handleChange}
//                 disabled={isSaving}
//                 required
//                 className="w-full rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
//               >
//                 <option value="">Select a country</option>
//                 {[
//                   'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda',
//                   'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas',
//                   'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin',
//                   'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei',
//                   'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon',
//                   'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia',
//                   'Comoros', 'Congo (Congo-Brazzaville)', 'Costa Rica', 'Croatia', 'Cuba',
//                   'Cyprus', 'Czechia (Czech Republic)', 'Denmark', 'Djibouti', 'Dominica',
//                   'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea',
//                   'Eritrea', 'Estonia', 'Eswatini (fmr. Swaziland)', 'Ethiopia', 'Fiji', 'Finland',
//                   'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada',
//                   'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Holy See', 'Honduras',
//                   'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel',
//                   'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait',
//                   'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya',
//                   'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia',
//                   'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius',
//                   'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco',
//                   'Mozambique', 'Myanmar (Burma)', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
//                   'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia',
//                   'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine State', 'Panama',
//                   'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
//                   'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia',
//                   'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe',
//                   'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore',
//                   'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa',
//                   'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden',
//                   'Switzerland', 'Syria', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste',
//                   'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan',
//                   'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom',
//                   'United States of America', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela',
//                   'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
//                 ].map((country) => (
//                   <option key={country} value={country}>
//                     {country}
//                   </option>
//                 ))}
//               </select>
//               {formErrors.country && <p className="text-red-500 text-sm mt-2">{formErrors.country}</p>}
//             </div>



//       {/* Any Specific Location */}
            
//           <div>
//             <Label htmlFor="anyspecificlocation">Any Specific Location</Label>
//             <textarea
//               id="anyspecificlocation"
//               name="anyspecificlocation"
//               value={form.anyspecificlocation || ""}
//               onChange={handleChange}
//               disabled={isSaving}
//               rows={3}
//               placeholder="Add Any Specific Location"
//               className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring focus:ring-blue-500"
//             />
//             {formErrors.anyspecificlocation && (
//               <p className="text-red-500 text-sm mt-1">{formErrors.anyspecificlocation}</p>
//             )}
//           </div>



//             <div>
//               <Label htmlFor="visaRejection">Visa Rejection</Label>
//               <select
//                 id="visaRejection"
//                 name="visaRejection"
//                 value={form.visaRejection || ''}
//                 onChange={handleChange}
//                 disabled={isSaving}
//                 className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//               >
//                 <option value="">Select Option</option>
//                 <option value="yes">Yes</option>
//                 <option value="no">No</option>
//               </select>
//               {formErrors.visaRejection && <p className="text-red-500 text-sm mt-2">{formErrors.visaRejection}</p>}
//             </div>

//             <div>
//               <Label htmlFor="travelHistory">Travel History</Label>
//               <select
//                 id="travelHistory"
//                 name="travelHistory"
//                 value={form.travelHistory || ''}
//                 onChange={handleChange}
//                 disabled={isSaving}
//                 className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//               >
//                 <option value="">Select Option</option>
//                 <option value="yes">Yes</option>
//                 <option value="no">No</option>
//               </select>
//               {formErrors.travelHistory && <p className="text-red-500 text-sm mt-2">{formErrors.travelHistory}</p>}
//             </div>
//           </div>
//         )}

//         {/* Program (only for Study Abroad) */}
//         {form.service === 'studyAbroad' && (
//           <div>
//             <Label htmlFor="program">Program</Label>
//             <Input
//               id="program"
//               name="program"
//               value={form.program || ''}
//               onChange={handleChange}
//               disabled={isSaving}
//             />
//             {formErrors.program && <p className="text-red-500 text-sm mt-2">{formErrors.program}</p>}
//           </div>
//         )}

//         {/* Exam Booking */}
//         {form.service === 'examBooking' && (
//           <>
//             <div>
//               <Label htmlFor="examType">Exam Type*</Label>
//               <select
//                 id="examType"
//                 name="examType"
//                 value={form.examType || ''}
//                 onChange={handleChange}
//                 disabled={isSaving}
//                 required
//                 className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//               >
//                 <option value="">Select Exam Type</option>
//                 <option value="ielts">IELTS</option>
//                 <option value="toefl">TOEFL</option>
//                 <option value="selt">SELT</option>
//                 <option value="pte">PTE</option>
//                 <option value="others">Others</option>
//               </select>
//               {formErrors.examType && <p className="text-red-500 text-sm mt-2">{formErrors.examType}</p>}
//             </div>

//             <div>
//               <Label htmlFor="ebd">Exam Booking Date</Label>
//               <Input
//                 id="ebd"
//                 name="ebd"
//                 type="date"
//                 value={form.ebd || ''}
//                 onChange={handleChange}
//                 disabled={isSaving}
//                 required
//               />
//               {formErrors.ebd && <p className="text-red-500 text-sm mt-1">{formErrors.ebd}</p>}
//             </div>
//           </>
//         )}

//         {/* Training */}
//         {form.service === 'training' && (
//           <div>
//             <Label htmlFor="examType">Training Type*</Label>
//             <select
//               id="examType"
//               name="examType"
//               value={form.examType || ''}
//               onChange={handleChange}
//               disabled={isSaving}
//               required
//               className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//             >
//               <option value="">Select Training</option>
//               <option value="ielts">IELTS</option>
//               <option value="toefl">TOEFL</option>
//               <option value="selt">SELT</option>
//               <option value="pte">PTE</option>
//               <option value="spokenEnglish">Spoken English</option>
//               <option value="others">Others</option>
//             </select>
//             {formErrors.examType && <p className="text-red-500 text-sm mt-2">{formErrors.examType}</p>}
//           </div>
//         )}

  

//         {/* Status */}
//         <div>
//           <Label htmlFor="status">Status*</Label>
//           <select
//             id="status"
//             name="status"
//             value={form.status || ''}
//             onChange={handleChange}
//             disabled={isSaving}
//             required
//             className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//           >
//             <option value="">Select Status</option>
//             <option value="registered">Registration</option>
//             <option value="onHold">On Hold</option>
//             <option value="closed">Closed</option>
//             <option value="cold">Cold</option>
//           </select>
//           {formErrors.status && <p className="text-red-500 text-sm mt-2">{formErrors.status}</p>}
//         </div>

//         {/* Payment Method */}
//         <div>
//           <Label htmlFor="payment">Payment Method</Label>
//           <select
//             id="payment"
//             name="payment"
//             value={form.payment || ''}
//             onChange={handleChange}
//             disabled={isSaving}
//             className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
//           >
//             <option value="">Select Payment Method</option>
//             <option value="cash">Cash</option>
//             <option value="card">Card</option>
//             <option value="online">Online</option>
//           </select>
//           {formErrors.payment && <p className="text-red-500 text-sm mt-2">{formErrors.payment}</p>}
//         </div>
//       </form>
//     </CardContent>
//   </Card>
// );

// EnrollmentInfoForm.propTypes = {
//   form: PropTypes.shape({
//     service: PropTypes.string,
//     country: PropTypes.string,
//     visaRejection: PropTypes.string,
//     travelHistory: PropTypes.string,
//     program: PropTypes.string,
//     examType: PropTypes.string,
//     ebd: PropTypes.string,
//     anyspecificlocation: PropTypes.string,
//     status: PropTypes.string,
//     payment: PropTypes.string,
//   }).isRequired,
//   handleChange: PropTypes.func.isRequired,
//   formErrors: PropTypes.object.isRequired,
//   isSaving: PropTypes.bool.isRequired,
// };

// export default EnrollmentInfoForm;





import PropTypes from 'prop-types';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';
import { useMemo } from 'react';

// Constants for reusable options
const SERVICE_OPTIONS = [
  { value: 'studyAbroad', label: 'Study Abroad' },
  { value: 'workpermit', label: 'Work Permit' },
  { value: 'touristVisa', label: 'Tourist Visa' },
  { value: 'examBooking', label: 'Exam Booking' },
  { value: 'training', label: 'Training' },
];

const COUNTRY_OPTIONS = [
"Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia",
  "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus",
  "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil",
  "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada",
  "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo (Congo-Brazzaville)",
  "Costa Rica", "Croatia", "Cuba", "Cyprus", "Czechia (Czech Republic)", "Denmark", "Djibouti", "Dominica",
  "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia",
  "Eswatini (fmr. Swaziland)", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia",
  "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti",
  "Holy See", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
  "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", "Kyrgyzstan", "Laos",
  "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
  "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
  "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco",
  "Mozambique", "Myanmar (Burma)", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua",
  "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
  "Palestine State", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal",
  "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
  "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia",
  "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands",
  "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname",
  "Sweden", "Switzerland", "Syria", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga",
  "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine",
  "United Arab Emirates", "United Kingdom", "United States of America", "Uruguay", "Uzbekistan", "Vanuatu",
  "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe",
];

const STATUS_OPTIONS = [
  { value: 'registration', label: 'Registration' },
  { value: 'onHold', label: 'On Hold' },
  { value: 'closed', label: 'Closed' },
  { value: 'cold', label: 'Cold' },
];

const EXAM_TYPE_OPTIONS = [
  { value: 'ielts', label: 'IELTS' },
  { value: 'toefl', label: 'TOEFL' },
  { value: 'selt', label: 'SELT' },
  { value: 'pte', label: 'PTE' },
  { value: 'spokenEnglish', label: 'Spoken English' }, // Added for training
  { value: 'others', label: 'Others' },
];

const PAYMENT_OPTIONS = [
  { value: 'cash', label: 'Cash' },
  { value: 'card', label: 'Card' },
  { value: 'online', label: 'Online' },
];

const YES_NO_OPTIONS = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

const EnrollmentInfoForm = ({ form, handleChange, formErrors, isSaving, onSubmit }) => {
  // Memoize country options to prevent unnecessary re-renders
  const countryOptions = useMemo(() => COUNTRY_OPTIONS.map((country) => ({
    value: country,
    label: country,
  })), []);

  // Handle form submission with basic validation
  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    if (!form.service) errors.service = 'Service is required';
    if (['studyAbroad', 'workpermit', 'touristVisa'].includes(form.service) && !form.country) {
      errors.country = 'Country is required';
    }
    if (form.service === 'examBooking' && !form.examType) {
      errors.examType = 'Exam Type is required';
    }
    if (form.service === 'training' && !form.examType) {
      errors.examType = 'Training Type is required';
    }
    if (!form.status) errors.status = 'Status is required';

    if (Object.keys(errors).length > 0) {
      // Pass errors to parent component or handle locally
      return;
    }
    onSubmit?.(form);
  };

  return (
    <Card className="p-4 max-w-2xl mx-auto">
      <CardHeader>
        <CardTitle>Enrollment Info</CardTitle>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Service */}
          <div>
            <Label htmlFor="service">Service*</Label>
            <Select
              id="service"
              name="service"
              value={form.service || ''}
              onValueChange={(value) => handleChange({ target: { name: 'service', value } })}
              disabled={isSaving}
              required
              aria-required="true"
              aria-invalid={!!formErrors.service}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select Service" />
              </SelectTrigger>
              <SelectContent>
                {SERVICE_OPTIONS.map(({ value, label }) => (
                  <SelectItem key={value} value={value}>
                    {label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {formErrors.service && <p className="text-red-500 text-sm mt-2">{formErrors.service}</p>}
          </div>

          {/* Conditional Fields for studyAbroad, workpermit, touristVisa */}
          {['studyAbroad', 'workpermit', 'touristVisa'].includes(form.service) && (
            <div className="space-y-4">
              {/* Country */}
              <div>
                <Label htmlFor="country">Country*</Label>
                <Select
                  id="country"
                  name="country"
                  value={form.country || ''}
                  onValueChange={(value) => handleChange({ target: { name: 'country', value } })}
                  disabled={isSaving}
                  required
                  aria-required="true"
                  aria-invalid={!!formErrors.country}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select a country" />
                  </SelectTrigger>
                  <SelectContent>
                    {countryOptions.map(({ value, label }) => (
                      <SelectItem key={value} value={value}>
                        {label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {formErrors.country && <p className="text-red-500 text-sm mt-2">{formErrors.country}</p>}
              </div>

             {/* Any Specific Location */}
              <div>
                <Label htmlFor="anyspecificlocation">Any Specific Location</Label>
                <Input
                  id="anyspecificlocation"
                  name="anyspecificlocation"
                  value={form.anyspecificlocation || ''}
                  onChange={handleChange}
                  disabled={isSaving}
                  aria-invalid={!!formErrors.anyspecificlocation}
                  placeholder="Enter specific location (optional)"
                />
                {formErrors.anyspecificlocation && (
                  <p className="text-red-500 text-sm mt-1">{formErrors.anyspecificlocation}</p>
                )}
              </div>


              {/* Visa Rejection */}
              <div>
                <Label htmlFor="visaRejection">Visa Rejection</Label>
                <Select
                  id="visaRejection"
                  name="visaRejection"
                  value={form.visaRejection || ''}
                  onValueChange={(value) => handleChange({ target: { name: 'visaRejection', value } })}
                  disabled={isSaving}
                  aria-invalid={!!formErrors.visaRejection}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Option" />
                  </SelectTrigger>
                  <SelectContent>
                    {YES_NO_OPTIONS.map(({ value, label }) => (
                      <SelectItem key={value} value={value}>
                        {label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {formErrors.visaRejection && <p className="text-red-500 text-sm mt-2">{formErrors.visaRejection}</p>}
              </div>

              {/* Travel History */}
              <div>
                <Label htmlFor="travelHistory">Travel History</Label>
                <Select
                  id="travelHistory"
                  name="travelHistory"
                  value={form.travelHistory || ''}
                  onValueChange={(value) => handleChange({ target: { name: 'travelHistory', value } })}
                  disabled={isSaving}
                  aria-invalid={!!formErrors.travelHistory}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Option" />
                  </SelectTrigger>
                  <SelectContent>
                    {YES_NO_OPTIONS.map(({ value, label }) => (
                      <SelectItem key={value} value={value}>
                        {label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {formErrors.travelHistory && <p className="text-red-500 text-sm mt-2">{formErrors.travelHistory}</p>}
              </div>
            </div>
          )}

          {/* Program (only for Study Abroad) */}
          {form.service === 'studyAbroad' && (
            <div>
              <Label htmlFor="program">Program</Label>
              <Input
                id="program"
                name="program"
                value={form.program || ''}
                onChange={handleChange}
                disabled={isSaving}
                aria-invalid={!!formErrors.program}
              />
              {formErrors.program && <p className="text-red-500 text-sm mt-2">{formErrors.program}</p>}
            </div>
          )}

          {/* Exam Booking */}
          {form.service === 'examBooking' && (
            <div className="space-y-4">
              <div>
                <Label htmlFor="examType">Exam Type*</Label>
                <Select
                  id="examType"
                  name="examType"
                  value={form.examType || ''}
                  onValueChange={(value) => handleChange({ target: { name: 'examType', value } })}
                  disabled={isSaving}
                  required
                  aria-required="true"
                  aria-invalid={!!formErrors.examType}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Exam Type" />
                  </SelectTrigger>
                  <SelectContent>
                    {EXAM_TYPE_OPTIONS.filter((opt) => opt.value !== 'spokenEnglish').map(({ value, label }) => (
                      <SelectItem key={value} value={value}>
                        {label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {formErrors.examType && <p className="text-red-500 text-sm mt-2">{formErrors.examType}</p>}
              </div>

              <div>
                <Label htmlFor="ebd">Exam Booking Date*</Label>
                <Input
                  id="ebd"
                  name="ebd"
                  type="date"
                  value={form.ebd || ''}
                  onChange={handleChange}
                  disabled={isSaving}
                  required
                  aria-required="true"
                  aria-invalid={!!formErrors.ebd}
                />
                {formErrors.ebd && <p className="text-red-500 text-sm mt-1">{formErrors.ebd}</p>}
              </div>
            </div>
          )}

          {/* Training */}
          {form.service === 'training' && (
            <div>
              <Label htmlFor="examType">Training Type*</Label>
              <Select
                id="examType"
                name="examType"
                value={form.examType || ''}
                onValueChange={(value) => handleChange({ target: { name: 'examType', value } })}
                disabled={isSaving}
                required
                aria-required="true"
                aria-invalid={!!formErrors.examType}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select Training" />
                </SelectTrigger>
                <SelectContent>
                  {EXAM_TYPE_OPTIONS.map(({ value, label }) => (
                    <SelectItem key={value} value={value}>
                      {label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {formErrors.examType && <p className="text-red-500 text-sm mt-2">{formErrors.examType}</p>}
            </div>
          )}

          {/* Status */}
          <div>
            <Label htmlFor="status">Status*</Label>
            <Select
              id="status"
              name="status"
              value={form.status || ''}
              onValueChange={(value) => handleChange({ target: { name: 'status', value } })}
              disabled={isSaving}
              required
              aria-required="true"
              aria-invalid={!!formErrors.status}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select Status" />
              </SelectTrigger>
              <SelectContent>
                {STATUS_OPTIONS.map(({ value, label }) => (
                  <SelectItem key={value} value={value}>
                    {label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {formErrors.status && <p className="text-red-500 text-sm mt-2">{formErrors.status}</p>}
          </div>

          {/* Payment Method */}
          <div>
            <Label htmlFor="payment">Payment Method</Label>
            <Select
              id="payment"
              name="payment"
              value={form.payment || ''}
              onValueChange={(value) => handleChange({ target: { name: 'payment', value } })}
              disabled={isSaving}
              aria-invalid={!!formErrors.payment}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select Payment Method" />
              </SelectTrigger>
              <SelectContent>
                {PAYMENT_OPTIONS.map(({ value, label }) => (
                  <SelectItem key={value} value={value}>
                    {label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {formErrors.payment && <p className="text-red-500 text-sm mt-2">{formErrors.payment}</p>}
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

EnrollmentInfoForm.propTypes = {
  form: PropTypes.shape({
    service: PropTypes.oneOf(['studyAbroad', 'workpermit', 'touristVisa', 'examBooking', 'training', '']),
    country: PropTypes.string,
    visaRejection: PropTypes.oneOf(['yes', 'no', '']),
    travelHistory: PropTypes.oneOf(['yes', 'no', '']),
    program: PropTypes.string,
    examType: PropTypes.oneOf(['ielts', 'toefl', 'selt', 'pte', 'spokenEnglish', 'others', '']),
    ebd: PropTypes.string,
    anyspecificlocation: PropTypes.string,
    status: PropTypes.oneOf(['registered', 'onHold', 'closed', 'cold', '']),
    payment: PropTypes.oneOf(['cash', 'card', 'online', '']),
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  formErrors: PropTypes.shape({
    service: PropTypes.string,
    country: PropTypes.string,
    visaRejection: PropTypes.string,
    travelHistory: PropTypes.string,
    program: PropTypes.string,
    examType: PropTypes.string,
    ebd: PropTypes.string,
    anyspecificlocation: PropTypes.string,
    status: PropTypes.string,
    payment: PropTypes.string,
  }).isRequired,
  isSaving: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func,
};

export default EnrollmentInfoForm;